import axios from "axios";
import { authStore } from "./authStore";
import { baseUrl, voiceBaseUrl } from "../config/apiConfig";

export function installAxiosAccess(instance) {
  instance.interceptors.request.use((config) => {
    if (config.authBootstrap) return config;
    const state = authStore.getSnapshot();
    config.accessRevision = state.revision;
    if (state.user?.client_id != null) {
      config.headers = config.headers || {};
      config.headers["X-Client-ID"] = String(state.user.client_id);
    }
    return config;
  });
  instance.interceptors.response.use((response) => {
    if (!response.config.authBootstrap && [401, 403].includes(response.data?.status)) {
      authStore.invalidate(response.data.status);
      return Promise.reject(new Error(response.data.message || "Access denied."));
    }
    if (!response.config.authBootstrap && response.config.accessRevision !== authStore.getSnapshot().revision) {
      return Promise.reject(new axios.CanceledError("Client context changed."));
    }
    return response;
  }, (error) => {
    if (!error.config?.authBootstrap && [401, 403].includes(error.response?.status)) authStore.invalidate(error.response.status);
    return Promise.reject(error);
  });
}

export function installFetchAccess() {
  const original = window.fetch.bind(window);
  const notificationBase = process.env.REACT_APP_NOTIFICATION_URL || (
    /^http:\/\/(localhost|127\.0\.0\.1):8000\/?$/.test(baseUrl) ? baseUrl.replace(":8000", ":8003") : baseUrl
  );
  const notificationOrigin = new URL(notificationBase, window.location.origin).origin;
  const apiOrigins = [baseUrl, voiceBaseUrl, notificationBase, "https://api.doclift.ai", process.env.REACT_APP_CHATBOT_API_URL, process.env.REACT_APP_WHATSAPP_API_URL]
    .filter(Boolean).map((url) => new URL(url, window.location.origin).origin);
  window.fetch = async (input, options = {}) => {
    const url = new URL(typeof input === "string" ? input : input.url, window.location.origin);
    const headers = new Headers(options.headers || (typeof input !== "string" ? input.headers : undefined));
    const authenticated = apiOrigins.includes(url.origin) && headers.has("Authorization");
    // The optional SSE gateway cannot invalidate the main API's login session.
    const notificationStream = url.origin === notificationOrigin
      && /^\/notifications\/bots\/[^/]+\/stream\/?$/.test(url.pathname);
    const state = authStore.getSnapshot();
    if (authenticated && state.user?.client_id != null) headers.set("X-Client-ID", String(state.user.client_id));
    const response = await original(input, { ...options, headers });
    if (authenticated) {
      if (!notificationStream && [401, 403].includes(response.status)) authStore.invalidate(response.status);
      if (state.revision !== authStore.getSnapshot().revision) throw new Error("Client context changed.");
    }
    return response;
  };
}
installAxiosAccess(axios);
